import { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import Conditional from '../common/Conditional'
import Icon from '../svg/Icon'
import TemplatePageBreadcrumbs from './TemplatePageBreadcrumbs'

const InteractiveTemplatesLeftHandNavigationMenu = () => {
  const govCMSHome = process.env.REACT_APP_GOVCMS_HOME
  const location = useLocation()
  const [index, setIndex] = useState(0)

  useEffect(() => {
    let selection = 0
    if (location.pathname.includes('end-of-probation')) {
      selection = 0
    } else if (location.pathname.includes('letter-of-resignation')) {
      selection = 1
    } else if (location.pathname.includes('warning-letter')) {
      selection = 2
    } else if (location.pathname.includes('request-for-records')) {
      selection = 3
    } else if (
      location.pathname.includes('notice-of-requirement-to-take-annual-leave')
    ) {
      selection = 4
    } else if (
      location.pathname.includes('agreement-to-take-annual-leave-in-advance')
    ) {
      selection = 5
    }
    setIndex(selection)
  }, [])

  const changeClass = (n: number) => {
    setIndex(n)
  }
  return (
    <>
      <Conditional
        if={
          location.pathname.includes('end-of-probation') ||
          location.pathname.includes('letter-of-resignation') ||
          location.pathname.includes('warning-letter') ||
          location.pathname.includes('request-for-records') ||
          location.pathname.includes(
            'notice-of-requirement-to-take-annual-leave'
          ) ||
          location.pathname.includes(
            'agreement-to-take-annual-leave-in-advance'
          )
        }
      >
        <TemplatePageBreadcrumbs />
      </Conditional>
      <div className="left-column">
        <div className="region region-sidebar-left">
          <nav className="vertical">
            <div
              className="settings-tray-editable block-mainnavigation"
              data-drupal-settingstray="editable"
            >
              <ul className="menu">
                <li className="expanded">
                  <Icon name="chevron-down-solid" width="20" height="20" />
                  <a
                    href={govCMSHome + '/tools-and-resources/templates'}
                    data-drupal-link-system-path="node/630"
                    className=""
                  >
                    Templates
                  </a>
                  <ul>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/end-of-probation"
                        className={index === 0 ? 'active' : ''}
                        onClick={() => changeClass(0)}
                      >
                        End of probation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/letter-of-resignation"
                        className={index === 1 ? 'active' : ''}
                        onClick={() => changeClass(1)}
                      >
                        Letter of resignation
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/warning-letter"
                        className={index === 2 ? 'active' : ''}
                        onClick={() => changeClass(2)}
                      >
                        Warning letter
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/request-for-records"
                        className={index === 3 ? 'active' : ''}
                        onClick={() => changeClass(3)}
                      >
                        Request for records
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/notice-of-requirement-to-take-annual-leave"
                        className={index === 4 ? 'active' : ''}
                        onClick={() => changeClass(4)}
                      >
                        Notice of requirement to take annual leave
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/tools-and-resources/templates/agreement-to-take-annual-leave-in-advance"
                        className={index === 5 ? 'active' : ''}
                        onClick={() => changeClass(5)}
                      >
                        Agreement to take annual leave in advance
                      </Link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  )
}
export default InteractiveTemplatesLeftHandNavigationMenu
